import { AxiosResponse } from 'axios';
import { RestServiceConnection } from '../restServiceConnection';

const ENDPOINT = '/call-classifications';

export class CallClassificationService extends RestServiceConnection {
    list = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    };

    create = async (data: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/create',
            data,
            headers: { 'Content-Type': 'application/json' },
        }, true) as AxiosResponse;
        return this;
    };

    edit = async (data: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/edit',
            data,
            headers: { 'Content-Type': 'application/json' },
        }, true) as AxiosResponse;
        return this;
    };

    delete = async (classificationId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete',
            data: { classificationId },
            headers: { 'Content-Type': 'application/json' },
        }, true) as AxiosResponse;
        return this;
    };
}
